// LEGO colors with proper shades for 3D effects
export const LEGO_COLORS_3D = [
  "#FFFFFF",
  "#1B2A34",
  "#C4281C",
  "#008F00",
  "#0054A6",
  "#FFF300",
  "#F15A22",
  "#7B2E7A",
  "#7B4B31",
  "#C7D5D3",
  "#696969",
  "#009E9E",
  "#8C8C8C",
  "#FF8000",
  "#4C92C1",
  "#EACE93",
  "#9B59B5",
  "#469947",
  "#274691",
  "#EEC4B6",
];

// Helper function to convert hex to RGB
export function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : { r: 0, g: 0, b: 0 };
}
